import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getMaterialKpi = (where: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `material/graph?where=` + where
  );
};
